import { useState } from 'react'
import { ClockCounterClockwiseIcon } from '@phosphor-icons/react'

import { PreviewHistoryModal } from '../PreviewHistoryModal'

import type { PreviewHistoryCardProps } from './types'

import * as S from './styles'

export const PreviewHistoryCard = ({ filters }: PreviewHistoryCardProps) => {
  const [isHistoryOpen, setIsHistoryOpen] = useState(false)

  return (
    <S.Container>
      <S.Info>
        <S.IconBox>
          <ClockCounterClockwiseIcon size={24} weight="bold" />
        </S.IconBox>

        <div>
          <S.Title>Histórico de Prévias</S.Title>
          <S.Description>Acesse o histórico das prévias da Competência atual</S.Description>
        </div>
      </S.Info>

      <S.HistoryButton colorType="solidBlue" width="328px" onClick={() => setIsHistoryOpen(true)}>
        Ver Histórico de Prévias
      </S.HistoryButton>

      <PreviewHistoryModal open={isHistoryOpen} onClose={() => setIsHistoryOpen(false)} initialFilters={filters} />
    </S.Container>
  )
}
